import React from 'react' // eslint-disable-line no-unused-vars
import { Link } from 'react-router-dom'
import StaticConfig from '../mi-app/StaticConfig'
import CountryAwareComponent from './CountryAwareComponent'
import { connect } from 'react-redux'
import { addNotification as notify } from 'reapop'
import Widget from '../elements/Widget'
import { wrapAnalyticsLinks } from '../helpers/analytics'
import PrescribingInformation from './modals/PrescribingInformation'
import GeneralRequests from './modals/GeneralRequests'
import ContactInformation from './modals/ContactInformation'
import {ENABLED_COUNTRIES, PERMISSIONS } from '../constants'
import privacyChoiceLinkImage from './assets/privacy_choice_link.png'


class Footer extends CountryAwareComponent {
  constructor (props) {
    super(props)
    this.state = {
      showPrescribingInfoModal: false,
      showGeneralRequestsModal: false,
      showContactInfoModal: false
    }
  }

  handlePrescribingInfoClick = () => this.setState({ showPrescribingInfoModal: !this.state.showPrescribingInfoModal })
  handleGeneralRequestsClick = () => this.setState({ showGeneralRequestsModal: !this.state.showGeneralRequestsModal })
  handleContactInfoClick = () => this.setState({ showContactInfoModal: !this.state.showContactInfoModal })
  allowBreakOnSlash = text => text ? text.split('/').reduce((a, b) => <React.Fragment>{`${a}/`}<wbr/>{b}</React.Fragment> ) : ''


  submitInquiryFooter = () => {
    const languageContent = this.props.pageContent.content

    return (
      <div className='row no-gutters'>
        <div className='col widget-mb-0-row d-flex submit-inquiry-info-box'>
          <Widget className='col'>
            <div className='row'>
              <div className='col text-center'>
                {/* <h5>{languageContent.module.submitInquiry.title}</h5> */}
                <p>
                  {
                    languageContent.module.findMyMSL.beforeSubmitInquiryLink
                  }
                </p>
              </div>
            </div>
            <div className='row'>
              <div className='col text-center'>
                <Link className='submit-inquiry-link' data-tag='track-link' data-analytics-text='Submit Inquiry' to='/submit-inquiry'>
                  {
                    this.props.permissions.indexOf(PERMISSIONS.PRODUCTS) !== -1 ? languageContent.module.findMyMSL.askAQuestionLink : languageContent.module.findMyMSL.submitInquiryLink
                  }
                </Link>
              </div>
            </div>
          </Widget>
        </div>
      </div>
    )
  }

  homeFooter = () => {
    const languageContent = this.props.pageContent.content

    return (
      <div className='row no-gutters'>
        <div className='col-lg-4 widget-mb-0-row d-flex prescribing-info-box'>
          <Widget className='col'>
            <div className='row'>
              <div className='col-12 text-xs-center text-lg-only-center' style={{ whiteSpace: 'pre-line' }}>
                <h5>{this.allowBreakOnSlash(languageContent.page.HOME.presInfo)}</h5>
                <p>{this.allowBreakOnSlash(languageContent.page.HOME.presInfoSub)}</p>
              </div>
            </div>
          </Widget>
          <button
            type='button'
            className='btn btn-primary btn-outline btn-lg-wide white-button btn-rounded'
            onClick={this.handlePrescribingInfoClick}
          >
            {languageContent.presInfogo}
          </button>
        </div>
        <div className='col-lg-4 widget-mb-0-row d-flex other-requests-box'>
          <Widget className='col'>
            <div className='row'>
              <div className='col-12 text-xs-center text-lg-only-center'>
                <h5>{languageContent.page.HOME.generalRequests}</h5>
                <p>{languageContent.page.HOME.generalReqSub}</p>
              </div>
            </div>
          </Widget>
          <button
            type='button'
            className='btn btn-primary btn-outline btn-lg-wide white-button btn-rounded'
            onClick={this.handleGeneralRequestsClick}
          >
            {languageContent.go}
          </button>
        </div>
        <div className='col-lg-4 widget-mb-0-row d-flex contact-info-box'>
          <Widget className='col'>
            <div className='row'>
              <div className='col-12 text-xs-center text-lg-only-center'>
                <h5>{languageContent.page.HOME.contactInfo}</h5>
                <p>{languageContent.page.HOME.contactInfoSub}</p>
              </div>
            </div>
          </Widget>
          <button
            type='button'
            className='btn btn-primary btn-outline btn-lg-wide white-button btn-rounded'
            onClick={this.handleContactInfoClick}
          >
            {languageContent.page.HOME.contactInfoGoButtonText}
          </button>
        </div>
      </div>
    )
  }

  componentDidUpdate () {
    wrapAnalyticsLinks('.footer', 'footer')
  }

  render () {
    const languageContent = this.props.pageContent.content
    const showSubmitInquiryFooter = this.props.submitInquiry !== false
    const showHomeFooter = this.props.showHomeFooter === true
    const CountryName = StaticConfig.Context.Country.name
    return (
      <div>
        {showSubmitInquiryFooter ? this.submitInquiryFooter() : null}
        {showHomeFooter ? this.homeFooter() : null}
        <div className='row footer no-gutters'>
          <div className='container'>
            <div className='row'>

              <div className='col-sm-12 text-center col-md-4'>
                <h6>{languageContent.page.HOME.medicalInquiryMenu.title}</h6>
                {
                  this.props.permissions.indexOf(PERMISSIONS.SUBMIT) !== -1 &&
                  <p>
                    <Link data-tag='track-link' data-analytics-text='Submit Inquiry' to='/submit-inquiry'>{languageContent.page.HOME.medicalInquiryMenu.submitInquiry}</Link>
                  </p>
                }
                { CountryName === 'Germany' &&
                 this.props.permissions.indexOf(PERMISSIONS.PRODUCTS) !== -1 &&
                  <p>
                  <a
                    data-tag='track-exit' data-analytics-text='Products'
                    href={languageContent.page.HOME.patient.germanyProducts} target='_blank'
                    rel='noopener noreferrer'
                  >{languageContent.page.HOME.patient.browseProducts}
                  </a>
                </p>
                }
                { CountryName !== 'Germany' &&
                  this.props.permissions.indexOf(PERMISSIONS.PRODUCTS) !== -1 &&
                  <p>
                    <Link data-tag='track-link' data-analytics-text='Products' to='/products'>
                    {languageContent.page.HOME.patient.browseProducts}</Link>
                  </p>
                }
                {
                  this.props.permissions.indexOf(PERMISSIONS.SEARCH) !== -1 &&
                  <p>
                    <Link data-tag='track-link' data-analytics-text='Search' to='/search'>{languageContent.page.HOME.medicalInquiryMenu.searchDoc}</Link>
                  </p>
                }
                <p onClick={this.handlePrescribingInfoClick} className='linkButton'>
                  {languageContent.page.HOME.medicalInquiryMenu.presInfo}
                </p>
                <p>
                  <a
                    data-tag='track-exit' data-analytics-text='General Requests'
                    href={languageContent.page.HOME.medicalInquiryMenu.generalRequestsLink}
                    target='_blank'
                    rel='noopener noreferrer'
                  >{languageContent.page.HOME.medicalInquiryMenu.generalRequests}
                  </a>
                </p>
              </div>
              <div className='col-sm-12 text-center col-md-4'>
                <h6>{languageContent.page.HOME.aboutTitle}</h6>
                {
                  this.props.permissions.indexOf(PERMISSIONS.ABOUT_US) !== -1 &&
                  <p>
                    <Link data-tag='track-link' data-analytics-text='About Us' to='/about-us'>{languageContent.module.aboutUs.aboutUs}</Link>
                  </p>
                }
                <p>
                  <Link to='/site-map'>{languageContent.page.HOME.siteMap}</Link>
                </p>
                <p>
                  <a
                    data-tag='track-exit' data-analytics-text='Research Innovation'
                    href={languageContent.page.HOME.researchInnovationLink} target='_blank'
                    rel='noopener noreferrer'
                  >{languageContent.page.HOME.researchInnovation}
                  </a>
                </p>
                <p>
                  <a
                    data-tag='track-exit' data-analytics-text='AbbVie Global'
                    href={languageContent.page.HOME.abbvieGlobalLink} target='_blank'
                    rel='noopener noreferrer'
                  >{languageContent.page.HOME.abbvieGlobal}
                  </a>
                </p>
              </div>
              <div className='col-sm-12 text-center col-md-4'>
                <h6>{languageContent.page.HOME.legalTitle}</h6>
                { CountryName === 'Germany' &&
                  <p>
                  <a
                    data-tag='track-exit' data-analytics-text='Terms of Use'
                    href={languageContent.page.HOME.termsOfUseLink} target='_blank'
                    rel='noopener noreferrer'
                  >{languageContent.page.HOME.termsOfUse}
                  </a>
                </p>
                }
                { CountryName !== 'Germany' &&
                  <p>
                  <a
                    data-tag='track-exit' data-analytics-text='Terms of Use'
                    href={languageContent.page.HOME.termsOfUseLink} target='_blank'
                    rel='noopener noreferrer'
                  >{languageContent.page.HOME.termsOfUse}
                  </a>
                </p>
                }
                { CountryName === 'United States' &&
                <p>
                  <a
                      data-tag='track-exit' data-analytics-text='Privacy Policy'
                      href={languageContent.page.HOME.privacyNoticeLink} target='_blank'
                      rel='noopener noreferrer'
                    >{languageContent.page.HOME.privacyPolicy}
                    </a>
                </p>
                }

                { CountryName === 'United States' &&
                <p>
                  <a
                    data-tag='track-exit' data-analytics-text='Privacy Notice'
                    href={languageContent.page.HOME.privacyNoticeLink} target='_blank'
                    rel='noopener noreferrer'
                  >{languageContent.page.HOME.privacyNotice}
                  </a>
                </p>
                }
                { CountryName !== 'United States' && CountryName !== 'Germany' &&
                  <p>
                    <a
                      data-tag='track-exit' data-analytics-text='Privacy Policy'
                      href={languageContent.page.HOME.privacyPolicyLink} target='_blank'
                      rel='noopener noreferrer'
                    >{languageContent.page.HOME.privacyPolicy}
                    </a>
                  </p>
                }
                { CountryName === 'Germany' &&
                <p>
                  <a
                    data-tag='track-exit' data-analytics-text='Privacy Notice'
                    href={languageContent.page.HOME.privacyNoticeLink} target='_blank'
                    rel='noopener noreferrer'
                  >{languageContent.page.HOME.privacyNotice}
                  </a>
                </p>
                }
                
                { CountryName !== 'Germany' && CountryName !== 'United States' &&
                <p>
                  <a
                    data-tag='track-exit' data-analytics-text='Privacy Notice'
                    href={languageContent.page.HOME.privacyNoticeLink} target='_blank'
                    rel='noopener noreferrer'
                  >{languageContent.page.HOME.privacyNotice}
                  </a>
                </p>
                }
                <p>
                  <a
                    data-tag='track-exit' data-analytics-text='Cookies Settings'
                    href="javascript:void(0)" id="ot-sdk-btn" className="ot-sdk-show-settings"
                    title="Overridden by OneTrust"
                  >{languageContent.page.HOME.cookiesSettings}
                  </a>
                </p>

                { ENABLED_COUNTRIES.includes(CountryName) &&
                <p>
                  <a
                    data-tag='track-exit' data-analytics-text='Your Privacy Choices'
                    href={languageContent.page.HOME.yourPrivacyChoiceLink} target='_blank'
                    rel='noopener noreferrer'
                  >{languageContent.page.HOME.yourPrivacyChoices}
                  </a>
                  <img src= {privacyChoiceLinkImage} alt='privacy icon' width='24px' />
                </p>
                }
              </div>
              <div className='col-12 mt-3 text-center'>
                <p><small>{languageContent.copyright}</small></p>
              </div>
            </div>
          </div>
        </div>
        {this.state.showPrescribingInfoModal && <PrescribingInformation toggle={this.handlePrescribingInfoClick}/>}
        {this.state.showGeneralRequestsModal && <GeneralRequests toggle={this.handleGeneralRequestsClick}/>}
        {this.state.showContactInfoModal && <ContactInformation toggle={this.handleContactInfoClick}/>}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    pageContent: state.pageContent,
    permissions: state.permissions
  }
}

export default connect(mapStateToProps, { notify })(Footer)



// WEBPACK FOOTER //
// ./src/mi-app/Footer.js